import { produce } from 'immer';
import { v4 } from 'uuid';
import { toastActions } from './types.esm.js';

var reducer = produce(function (draft, action) {
    switch (action.type) {
        case toastActions.add: {
            var _a = action.payload, text = _a.text, _b = _a.autoDismiss, autoDismiss = _b === void 0 ? true : _b, _c = _a.appearance, appearance = _c === void 0 ? "clear" : _c;
            var id = v4();
            draft.toasts.unshift({ text: text, autoDismiss: autoDismiss, appearance: appearance, id: id });
            break;
        }
        case toastActions.remove: {
            draft.toasts = draft.toasts.filter(function (toast) { return toast.id !== action.payload; });
            break;
        }
        case toastActions.clear: {
            draft.toasts = [];
            break;
        }
    }
});

export { reducer };
//# sourceMappingURL=reducer.esm.js.map
